import io from 'socket.io-client';
import Auth from './AuthService';
import config from '../config';

// socket.io options
const options = {
  // go straight to WebSockets
  transports: ['websocket'],
  // query: {
  //   token: localStorage.getItem('token'),
  // },
};

const SocketService = {
  sockets: {},
  namespaces: ['global', 'notifications', 'chat', 'db', 'list'],

  init() {
    this.namespaces.forEach((ns) => {
      if (ns === 'global') {
        this.sockets[ns] = io(config.serverUrl, options);
      } else {
        this.sockets[ns] = io(`${config.serverUrl}/${ns}`, options);
      }

      // set alias to namespaces
      this[ns] = this.sockets[ns];

      const self = this;

      // monkey patch on to add disposer option
      const oldOn = this[ns].on;
      this[ns].on = function (event, fn, disposer = false) {
        const ret = oldOn.call(this, event, fn);
        if (disposer) {
          return () => {
            self[ns].off(event, fn);
          };
        }

        return ret;
      };

      this[ns].joined = {};
      this[ns].join = function (name) {
        if (self[ns].joined[name]) {
          self[ns].joined[name]();
        }
        self[ns].emit('join', name);
        self[ns].joined[name] = self[ns].on('connect', () => self[ns].join(name), true);
      };

      this[ns].leave = function (name) {
        self[ns].emit('leave', name);

        // dispose connection listeners
        if (self[ns].joined[name]) {
          self[ns].joined[name]();
        }
      };
    });

    this.global.on('connect', () => this.login());
  },

  login() {
    this.global.emit('login', Auth.getSessionToken());
  },

  logout() {
    this.global.emit('logout', Auth.getSessionToken());
  },
};

SocketService.init();

export default SocketService;
